import React, { useRef, useState } from 'react';
import styles from './index.module.scss';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import imgLeftPic from '@/assets/home/new-screen8-left-pic.png';
import imgRightPic from '@/assets/home/new-screen8-right-pic.png';

// 第八屏：权威认证 品质保证
export default function Screen8() {
  const [activeCard, setActiveCard] = useState<'left' | 'right' | null>('left');
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen8-anim-start'],
  });
  const screenRef = useRef<HTMLDivElement>(null);

  return (
    <section className={styles['screen8-cover']} ref={slideInRef.ref}>
      {/* 标题 */}
      <div className={styles['screen8-title-container']}>
        <h2 className={styles['screen8-title']}>权威认证 品质保证</h2>
      </div>

      <div className={styles['screen8-cards']}>
        <div
          className={`${styles['screen8-card']} ${styles['screen8-card-left']} ${
            activeCard === 'left' ? styles['active'] : styles['inactive']
          }`}
          onMouseEnter={() => setActiveCard('left')}
        >
          <div className={styles['screen8-card-pic-wrap1']} aria-hidden>
            <img src={imgLeftPic} alt="" className={styles['screen8-card-pic']} loading="lazy" />
          </div>
          <span
            className={`${styles['screen8-card-num']} ${styles['screen8-card-num-left']}`}
            aria-hidden
          >
            01
          </span>
          <div className={styles['screen8-card-content-left']}>
            <div className={styles['screen8-card-content-inner']}>
              <h3 className={styles['screen8-card-title']}>
                <span className={styles['screen8-card-title-line']}>"人工智能+"</span>
                <span className={styles['screen8-card-title-line']}>创新应用实践案例</span>
              </h3>
              <p className={styles['screen8-card-subtitle']}>
                发放机构：新华网联合工业与信息化部软件与集成电路促进中心
              </p>
            </div>
          </div>
        </div>

        <div
          className={`${styles['screen8-card']} ${styles['screen8-card-right']} ${
            activeCard === 'right' ? styles['active'] : styles['inactive']
          }`}
          onMouseEnter={() => setActiveCard('right')}
        >
          <div className={styles['screen8-card-pic-wrap2']} aria-hidden>
            <img src={imgRightPic} alt="" className={styles['screen8-card-pic']} loading="lazy" />
          </div>
          <span
            className={`${styles['screen8-card-num']} ${styles['screen8-card-num-right']}`}
            aria-hidden
          >
            02
          </span>
          <div className={styles['screen8-card-content-right']}>
            <h3 className={styles['screen8-card-title']}>
              <span className={styles['screen8-card-title-line']}>"教育+"</span>
              <span className={styles['screen8-card-title-line']}>AI先锋企业奖</span>
            </h3>
            <p className={styles['screen8-card-subtitle']}>发放机构：2025GET教育科技大会 </p>
          </div>
        </div>
      </div>
    </section>
  );
}
